import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';

import {
  getColumnKey,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { isNil, isNotNil } from '@web/utils';
import {
  OrderRefundCollectionItem,
  RefundStatusComponent,
  RefundTypeComponent,
} from '@web/shared/module/shop';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { AdminInvoiceDataSourceService } from '../../services/admin-invoice-data-source.service';

@Component({
  selector: 'app-admin-order-refund-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    RefundStatusComponent,
    RefundTypeComponent,
    NoDataComponent,
    Button,
    Tooltip,
  ],
  templateUrl: './admin-order-refund-list-custom-cell-template.component.html',
  styleUrl: './admin-order-refund-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminOrderRefundListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<OrderRefundCollectionItem, never>>();
  /* prettier-ignore */
  public readonly model = input.required<OrderRefundCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<OrderRefundCollectionItem>;
  protected readonly isNotNil = isNotNil;

  private readonly invoiceDataSource = inject(AdminInvoiceDataSourceService);

  public handleDownloadInvoiceClick(): void {
    const invoiceId = this.model().invoiceId;

    if (isNil(invoiceId)) {
      return;
    }

    this.invoiceDataSource.downloadRefundInvoiceById(invoiceId).subscribe();
  }
}
